/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';

const style: ouiStyle.InStyleWithMediaQueries = {
  display: [ouiStyle.Constants.DisplayProp.flex, undefined, ouiStyle.Constants.DisplayProp.hidden, undefined, undefined, undefined],
};

const css = ouiStyle.mediaQuery(ouiStyle.makeCss(style));

export const AccountTypeMobileSelectorContainer = (props: React.PropsWithChildren<{}>) => {
  const {
    children,
  } = props;
  return (
    <nav
      css={css}
    >
      {children}
    </nav>
  );
};
